import React from 'react'

import useStyles from './styles'

const NotificationIcon = ({ children }) => {
  const classes = useStyles()

  return <div className={classes.root}>{children}</div>
}

export default NotificationIcon
